import * as React from "react";
import type { SVGProps } from "react";
const SvgWallert04 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20.64 14.76v2.44a2 2 0 0 1-2 2H4.4a2 2 0 0 1-2-2V6.8a2 2 0 0 1 2-2h14.24a2 2 0 0 1 2 2v2.37m.96 5.59h-3.12a2.64 2.64 0 1 1 0-5.28h3.12z"
    />
  </svg>
);
export default SvgWallert04;
